import React from 'react';
import { ChatMessage } from './ChatMessage';
import { Avatar, Box, Text } from '@wix/design-system';
import s from './ChatMessage.module.scss';
import { Theme } from '../../types';
import { StyledText } from '../TextTyper/StyledText';

interface UserChatMessageProps {
  dataHook?: string;
  content: string;
  userImage?: string;
  userDisplayName?: string;
  theme: Theme;
}

export const UserChatMessage: React.FC<UserChatMessageProps> = ({
  dataHook,
  content,
  userImage,
  userDisplayName,
  theme,
}) => {
  return (
    <ChatMessage
      dataHook={dataHook}
      className={s.messageUser}
      name={userDisplayName || 'You'}
      img={
        <Avatar
          shape="circle"
          size="size30"
          className={s.userAvatar}
          name={userDisplayName}
          imgProps={{ src: userImage }}
        />
      }
      theme={theme}
    >
      <StyledText>
        <Box direction="vertical">
          {content.split('\n').map((x: string, index) => (
            <Text className={s.userNonTypedText} key={index}>
              {x}
            </Text>
          ))}
        </Box>
      </StyledText>
    </ChatMessage>
  );
};
